import { findIndex, find, get } from 'lodash';

export const tokenSelector = ( {user} ) => user.token;
export const nextQuestionSelector = ({serie}) => {
  return serie.nextQuestion[serie.currentSerie];
}
export const questionIndexSelector = (questionId) => ({serie}) => {
  return findIndex(get(find(serie.series, s => s.id === serie.currentSerie), 'questions'), q => q === questionId);
}